import React from "react";
import { Redirect, Route, useParams } from "react-router-dom";
import ProductPageContainer from "../containers/ProductPageContainer";
import { ClientProductTypesList } from "../../common/interfaces/enums/ProductType";
import ProductSettingPage from "../pages/ProductSettingPage/ProductSettingPage";

const ProductRedirect: React.FC = () => {
    const { product } = useParams<{ product: string }>();

    return <Redirect to={`/products?product=${product}`} />;
};

const ProductRoutes: React.FC = () => {
    return (
        <React.Fragment>
            {ClientProductTypesList.map((product) => {
                return (
                    <React.Fragment key={product}>
                        <Route exact path={`/:product`}>
                            <ProductRedirect />
                        </Route>

                        <Route exact path={`/${product}/settings`}>
                            <ProductPageContainer productType={product} hasFamilyRedirect>
                                <ProductSettingPage productType={product} />
                            </ProductPageContainer>
                        </Route>
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

export default ProductRoutes;
